module.exports = __webpack_public_path__ + "fonts/DM_Sans-700-latin15.3ccd9ab.woff2";